import axiosInstance from "./AxiosInstance";

export function createSyncInvoiceProduct(data) {
  return axiosInstance.post(`/syncproduct`, data);
}



